import React from 'react'
import { AiFillStar, AiOutlineStar } from "react-icons/ai";

function Star({rating}) {
  const rate = Math.round(rating);

  return (
    <div>
      {
        [...Array(5)].map((_, i)=>{
          return rate > i ? (<AiFillStar  style={{color:"#ffd700"}}  />) : (<AiOutlineStar/>)
        })
      }
        <AiOutlineStar/>
    </div>
  )
}

export default Star